import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { BareFundChartWrapperModule } from 'ChartApp/ts/features/bare-fund-chart-wrapper/bare-fund-chart-wrapper.module';
import { PerformanceChartModule } from 'ChartApp/ts/features/performance-chart/performance-chart.module';
import { SingleSeriesFundChartModule } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.module';
import { StocksFundamentalsAppModule } from 'CompanyApp/ts/apps/stocks-fundamentals-app/stocks-fundamentals-app.module';
import { EstimatePeriodModule } from 'CompanyApp/ts/features/estimate-periods/estimate-period.module';
import { StocksEditProfileModalButtonModule } from 'CompanyApp/ts/features/stocks-edit-profile-modal-button/stocks-edit-profile-modal-button.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { IconWrapperModule } from 'NewAngular/features/components/icon-wrapper/icon-wrapper.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ComparablesModalButtonModule } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.module';
import { NewsAIChatModule } from 'SecuritiesApp/ts/features/news-ai-chat/news-ai-chat.module';
import { PerformanceIncludeBenchmarkCheckboxModule } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox.module';
import { RiskInfoCheckboxesModule } from 'SecuritiesApp/ts/features/risk-info-checkboxes/risk-info-checkboxes.module';
import { RiskInfoScatterPlotModule } from 'SecuritiesApp/ts/features/risk-info-scatter-plot/risk-info-scatter-plot.module';
import { RiskLookbackModule } from 'SecuritiesApp/ts/features/risk-lookback/risk-lookback.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { TopPortfolioHoldingsModule } from 'SecuritiesApp/ts/features/top-portfolio-holdings/top-portfolio-holdings.module';
import { BareFundChartWrapperComponent } from 'ChartApp/ts/features/bare-fund-chart-wrapper/bare-fund-chart-wrapper.component';
import { GeneralChartComponent } from 'ChartApp/ts/features/general-chart/components/general-chart/general-chart.component';
import { GeneralChartResponsiveComponent } from 'ChartApp/ts/features/general-chart/components/general-chart-responsive/general-chart-responsive.component';
import { PerformanceChartComponent } from 'ChartApp/ts/features/performance-chart/performance-chart.component';
import { SingleSeriesFundChartComponent } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.component';
import { ChartTypeButtonComponent } from 'CompanyApp/ts/apps/stocks-fundamentals-app/chart-type-button.component';
import { FundamentalsTabsComponent } from 'CompanyApp/ts/apps/stocks-fundamentals-app/fundamentals-tabs.component';
import { PeriodToggleComponent } from 'CompanyApp/ts/features/estimate-periods/period-toggle/period-toggle.component';
import { StocksEditProfileModalButtonComponent } from 'CompanyApp/ts/features/stocks-edit-profile-modal-button/stocks-edit-profile-modal-button.component';
import { IconWrapperComponent } from 'NewAngular/features/components/icon-wrapper/icon-wrapper.component';
import { HelpModalWithTriggerComponent } from 'NewAngular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { ComparablesModalButtonComponent } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.component';
import { NewsAIChatComponent } from 'SecuritiesApp/ts/features/news-ai-chat/news-ai-chat.component';
import { RiskInfoCheckboxesComponent } from 'SecuritiesApp/ts/features/risk-info-checkboxes/risk-info-checkboxes.component';
import { RiskInfoScatterPlotComponent } from 'SecuritiesApp/ts/features/risk-info-scatter-plot/risk-info-scatter-plot.component';
import { RiskLookbackComponent } from 'SecuritiesApp/ts/features/risk-lookback/risk-lookback.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { TopPortfolioHoldingsComponent } from 'SecuritiesApp/ts/features/top-portfolio-holdings/top-portfolio-holdings.component';
import { getLogger } from 'NewAngular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import { PerformanceIncludeBenchmarkCheckboxComponent } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    BareFundChartWrapperComponent,
    ComparablesModalButtonComponent,
    FundamentalsTabsComponent,
    GeneralChartComponent,
    HelpModalWithTriggerComponent,
    IconWrapperComponent,
    NewsAIChatComponent,
    SideMenuComponent,
    RiskInfoCheckboxesComponent,
    RiskInfoScatterPlotComponent,
    RiskLookbackComponent,
    SecurityHeaderControlComponent,
    SingleSeriesFundChartComponent,
    StocksEditProfileModalButtonComponent,
    TopBarNavComponent,
    TopPortfolioHoldingsComponent,
];
export class StocksQuoteModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [
            BareFundChartWrapperComponent,
            ChartTypeButtonComponent,
            ComparablesModalButtonComponent,
            FundamentalsTabsComponent,
            GeneralChartComponent,
            GeneralChartResponsiveComponent,
            HelpModalWithTriggerComponent,
            IconWrapperComponent,
            NewsAIChatComponent,
            PerformanceChartComponent,
            PerformanceIncludeBenchmarkCheckboxComponent,
            PeriodToggleComponent,
            RiskInfoCheckboxesComponent,
            RiskInfoScatterPlotComponent,
            RiskLookbackComponent,
            SingleSeriesFundChartComponent,
            StocksEditProfileModalButtonComponent,
            TopPortfolioHoldingsComponent,
        ];
    }
}
StocksQuoteModule.ɵfac = function StocksQuoteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StocksQuoteModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
StocksQuoteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StocksQuoteModule });
StocksQuoteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        FormsModule,
        BareFundChartWrapperModule,
        ConfigModule,
        CommonModule,
        EstimatePeriodModule,
        HelpModalModule,
        NavigationModule,
        NewsAIChatModule,
        RiskInfoCheckboxesModule,
        RiskInfoScatterPlotModule,
        RiskLookbackModule,
        SecurityHeaderControlModule,
        SingleSeriesFundChartModule,
        PerformanceChartModule,
        PerformanceIncludeBenchmarkCheckboxModule,
        ComparablesModalButtonModule,
        IconModule,
        IconWrapperModule,
        StocksEditProfileModalButtonModule,
        StocksFundamentalsAppModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        TopPortfolioHoldingsModule] });
